import { toDisplayString as _toDisplayString, vShow as _vShow, createElementVNode as _createElementVNode, withDirectives as _withDirectives, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4c734d25"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  ref: "container",
  class: "full"
}
const _hoisted_2 = { class: "search-panel__filters" }
const _hoisted_3 = /*#__PURE__*/_createTextVNode("Skip to results")
const _hoisted_4 = ["aria-hidden"]
const _hoisted_5 = { class: "search-panel__filters-lists__header" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Filters", -1))
const _hoisted_7 = ["onClick", "aria-disabled"]
const _hoisted_8 = ["onClick"]
const _hoisted_9 = ["onClick"]
const _hoisted_10 = ["onClick"]
const _hoisted_11 = { class: "search-panel__results" }
const _hoisted_12 = { class: "search-panel__results__header" }
const _hoisted_13 = { key: 0 }
const _hoisted_14 = /*#__PURE__*/_createTextVNode("for ")
const _hoisted_15 = { class: "badge-list" }
const _hoisted_16 = {
  class: "search-panel__results__list",
  id: "search-results",
  tabindex: "-1"
}
const _hoisted_17 = ["id"]
const _hoisted_18 = {
  role: "navigation",
  class: "search-panel__pagination"
}
const _hoisted_19 = { key: 0 }
const _hoisted_20 = /*#__PURE__*/_createTextVNode(" ‹‹ ")
const _hoisted_21 = { key: 1 }
const _hoisted_22 = /*#__PURE__*/_createTextVNode(" ‹ ")
const _hoisted_23 = { key: 2 }
const _hoisted_24 = /*#__PURE__*/_createTextVNode(" › ")
const _hoisted_25 = { key: 3 }
const _hoisted_26 = /*#__PURE__*/_createTextVNode(" ›› ")
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "search-panel__promotional" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_skip_link = _resolveComponent("skip-link")!
  const _component_ais_clear_refinements = _resolveComponent("ais-clear-refinements")!
  const _component_filter_list = _resolveComponent("filter-list")!
  const _component_ais_refinement_list = _resolveComponent("ais-refinement-list")!
  const _component_ais_stats = _resolveComponent("ais-stats")!
  const _component_close_button = _resolveComponent("close-button")!
  const _component_ais_current_refinements = _resolveComponent("ais-current-refinements")!
  const _component_search_event = _resolveComponent("search-event")!
  const _component_ais_hits = _resolveComponent("ais-hits")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_ais_pagination = _resolveComponent("ais-pagination")!
  const _component_ais_search_box = _resolveComponent("ais-search-box")!
  const _component_ais_instant_search = _resolveComponent("ais-instant-search")!
  const _component_layout = _resolveComponent("layout")!

  return (_openBlock(), _createBlock(_component_layout, {
    full: true,
    "search-query": _ctx.routing.router.read()
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_ais_instant_search, {
          "search-client": _ctx.searchClient,
          "index-name": _ctx.indexName,
          routing: _ctx.routing,
          "class-names": {
          'ais-InstantSearch': 'search-panel',
        }
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_2, [
              _withDirectives(_createElementVNode("button", {
                onClick: _cache[0] || (_cache[0] = () => (_ctx.showFilters = !_ctx.showFilters)),
                class: "secondary-button search-panel__filters__button"
              }, _toDisplayString(_ctx.showFilters ? "Hide filters" : "Show filters"), 513), [
                [_vShow, _ctx.isMobile]
              ]),
              _createVNode(_component_skip_link, {
                class: "skip-link",
                hash: "#search-results"
              }, {
                default: _withCtx(() => [
                  _hoisted_3
                ]),
                _: 1
              }),
              _withDirectives(_createElementVNode("div", {
                class: "search-panel__filters-lists",
                "aria-hidden": !_ctx.showFilters
              }, [
                _createElementVNode("div", _hoisted_5, [
                  _hoisted_6,
                  _createVNode(_component_ais_clear_refinements, null, {
                    default: _withCtx(({ canRefine, refine }) => [
                      _createElementVNode("button", {
                        onClick: _withModifiers(refine, ["prevent"]),
                        "aria-disabled": !canRefine,
                        class: "link-button"
                      }, " Reset filters ", 8, _hoisted_7)
                    ]),
                    _: 1
                  })
                ]),
                _createVNode(_component_ais_refinement_list, {
                  attribute: "Venue.State",
                  "class-names": {
                'ais-RefinementList': 'search-panel__filters-lists__list',
              }
                }, {
                  default: _withCtx(({ items, refine }) => [
                    _createVNode(_component_filter_list, {
                      title: "Location",
                      items: items,
                      refine: refine
                    }, null, 8, ["items", "refine"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_ais_refinement_list, {
                  attribute: "Categories",
                  "show-more": "",
                  "class-names": {
                'ais-RefinementList': 'search-panel__filters-lists__list',
              }
                }, {
                  default: _withCtx(({
                  items,
                  isShowingMore,
                  toggleShowMore,
                  canToggleShowMore,
                  refine,
                }) => [
                    _createVNode(_component_filter_list, {
                      title: "Categories",
                      items: items,
                      refine: refine
                    }, null, 8, ["items", "refine"]),
                    canToggleShowMore
                      ? (_openBlock(), _createElementBlock("button", {
                          key: 0,
                          class: "link-button search-panel__filters-lists__list__showmore",
                          onClick: toggleShowMore
                        }, _toDisplayString(!isShowingMore
                        ? "Show more categories"
                        : "Show fewer categories"), 9, _hoisted_8))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                }),
                _createVNode(_component_ais_refinement_list, {
                  attribute: "Bands",
                  "show-more": "",
                  "class-names": {
                'ais-RefinementList': 'search-panel__filters-lists__list',
              }
                }, {
                  default: _withCtx(({
                  items,
                  isShowingMore,
                  toggleShowMore,
                  canToggleShowMore,
                  refine,
                }) => [
                    _createVNode(_component_filter_list, {
                      title: "Artists",
                      items: items,
                      refine: refine
                    }, null, 8, ["items", "refine"]),
                    canToggleShowMore
                      ? (_openBlock(), _createElementBlock("button", {
                          key: 0,
                          class: "link-button search-panel__filters-lists__list__showmore",
                          onClick: toggleShowMore
                        }, _toDisplayString(!isShowingMore ? "Show more artists" : "Show fewer artists"), 9, _hoisted_9))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                }),
                _createVNode(_component_ais_refinement_list, {
                  attribute: "Venue.Name",
                  "show-more": "",
                  "class-names": {
                'ais-RefinementList': 'search-panel__filters-lists__list',
              }
                }, {
                  default: _withCtx(({
                  items,
                  isShowingMore,
                  toggleShowMore,
                  canToggleShowMore,
                  refine,
                }) => [
                    _createVNode(_component_filter_list, {
                      title: "Venue",
                      items: items,
                      refine: refine
                    }, null, 8, ["items", "refine"]),
                    canToggleShowMore
                      ? (_openBlock(), _createElementBlock("button", {
                          key: 0,
                          class: "link-button search-panel__filters-lists__list__showmore",
                          onClick: toggleShowMore
                        }, _toDisplayString(!isShowingMore ? "Show more venues" : "Show fewer venues"), 9, _hoisted_10))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                })
              ], 8, _hoisted_4), [
                [_vShow, _ctx.showFilters]
              ])
            ]),
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("div", _hoisted_12, [
                _createVNode(_component_ais_stats, null, {
                  default: _withCtx(({ nbHits, query }) => [
                    _createElementVNode("h2", null, [
                      _createTextVNode(_toDisplayString(nbHits) + " events found ", 1),
                      query
                        ? (_openBlock(), _createElementBlock("span", _hoisted_13, [
                            _hoisted_14,
                            _createElementVNode("q", null, _toDisplayString(query), 1)
                          ]))
                        : _createCommentVNode("", true)
                    ])
                  ]),
                  _: 1
                }),
                _createVNode(_component_ais_current_refinements, null, {
                  default: _withCtx(({ items }) => [
                    _createElementVNode("ul", _hoisted_15, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(items, (item) => {
                        return (_openBlock(), _createElementBlock(_Fragment, null, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.refinements, (refinement) => {
                            return (_openBlock(), _createElementBlock("li", {
                              key: 
                        [
                          refinement.attribute,
                          refinement.type,
                          refinement.value,
                          refinement.operator,
                        ].join(':')
                      ,
                              class: "badge"
                            }, [
                              _createElementVNode("span", null, _toDisplayString(refinement.label), 1),
                              _createVNode(_component_close_button, {
                                label: `Remove ${refinement.label}`,
                                onClick: ($event: any) => (item.refine(refinement))
                              }, null, 8, ["label", "onClick"])
                            ]))
                          }), 128))
                        ], 64))
                      }), 256))
                    ])
                  ]),
                  _: 1
                })
              ]),
              _createVNode(_component_ais_hits, null, {
                default: _withCtx(({ items }) => [
                  _createElementVNode("ul", _hoisted_16, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(items, (item, index) => {
                      return (_openBlock(), _createElementBlock("li", {
                        key: item.objectID,
                        id: `result-${index + 1}`,
                        tabindex: "-1"
                      }, [
                        _createVNode(_component_search_event, {
                          "event-key": item.EventId,
                          name: item.EventName,
                          day: _ctx.getDay(item.DateStart, item.Venue.Timezone),
                          date: _ctx.getDate(item.DateStart, item.Venue.Timezone),
                          where: `${item.Venue.Name}, ${item.Venue.Locality}, ${item.Venue.State}`,
                          image: item.EventImage1,
                          url: _ctx.getEventUrlWithSearchUtm(item.EventUrl),
                          "is-bookmarked": 
                      _ctx.bookmarkedEventKeys &&
                      _ctx.bookmarkedEventKeys.includes(item.EventId)
                    ,
                          onViewed: ($event: any) => (_ctx.onEventViewed(item.EventId, index)),
                          onBookmark: ($event: any) => (_ctx.onBookmarkEvent(item.EventId, index)),
                          onClicked: _cache[1] || (_cache[1] = ($event: any) => (_ctx.onEventClicked(_ctx.event.eventKey, _ctx.i)))
                        }, null, 8, ["event-key", "name", "day", "date", "where", "image", "url", "is-bookmarked", "onViewed", "onBookmark"])
                      ], 8, _hoisted_17))
                    }), 128))
                  ])
                ]),
                _: 1
              }),
              _createElementVNode("nav", _hoisted_18, [
                _createVNode(_component_ais_pagination, null, {
                  default: _withCtx(({
                  currentRefinement,
                  nbPages,
                  pages,
                  isFirstPage,
                  isLastPage,
                  refine,
                  createURL,
                }) => [
                    _withDirectives(_createElementVNode("ul", null, [
                      (!isFirstPage)
                        ? (_openBlock(), _createElementBlock("li", _hoisted_19, [
                            _createVNode(_component_router_link, {
                              to: createURL(0),
                              onClick: _withModifiers(($event: any) => (refine(0)), ["prevent"]),
                              "aria-label": "First page"
                            }, {
                              default: _withCtx(() => [
                                _hoisted_20
                              ]),
                              _: 2
                            }, 1032, ["to", "onClick"])
                          ]))
                        : _createCommentVNode("", true),
                      (!isFirstPage)
                        ? (_openBlock(), _createElementBlock("li", _hoisted_21, [
                            _createVNode(_component_router_link, {
                              to: createURL(currentRefinement - 1),
                              onClick: _withModifiers(($event: any) => (refine(currentRefinement - 1)), ["prevent"]),
                              "aria-label": "Previous page"
                            }, {
                              default: _withCtx(() => [
                                _hoisted_22
                              ]),
                              _: 2
                            }, 1032, ["to", "onClick"])
                          ]))
                        : _createCommentVNode("", true),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(pages, (page) => {
                        return (_openBlock(), _createElementBlock("li", { key: page }, [
                          _createVNode(_component_router_link, {
                            to: createURL(page),
                            onClick: _withModifiers(($event: any) => (refine(page)), ["prevent"]),
                            "aria-current": currentRefinement == page ? 'page' : ''
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(page + 1), 1)
                            ]),
                            _: 2
                          }, 1032, ["to", "onClick", "aria-current"])
                        ]))
                      }), 128)),
                      (!isLastPage)
                        ? (_openBlock(), _createElementBlock("li", _hoisted_23, [
                            _createVNode(_component_router_link, {
                              to: createURL(currentRefinement + 1),
                              onClick: _withModifiers(($event: any) => (refine(currentRefinement + 1)), ["prevent"]),
                              "aria-label": "Next page"
                            }, {
                              default: _withCtx(() => [
                                _hoisted_24
                              ]),
                              _: 2
                            }, 1032, ["to", "onClick"])
                          ]))
                        : _createCommentVNode("", true),
                      (!isLastPage)
                        ? (_openBlock(), _createElementBlock("li", _hoisted_25, [
                            _createVNode(_component_router_link, {
                              to: createURL(nbPages),
                              onClick: _withModifiers(($event: any) => (refine(nbPages)), ["prevent"]),
                              "aria-label": "Last page"
                            }, {
                              default: _withCtx(() => [
                                _hoisted_26
                              ]),
                              _: 2
                            }, 1032, ["to", "onClick"])
                          ]))
                        : _createCommentVNode("", true)
                    ], 512), [
                      [_vShow, nbPages > 1]
                    ])
                  ]),
                  _: 1
                })
              ])
            ]),
            _hoisted_27,
            _withDirectives(_createVNode(_component_ais_search_box, {
              value: this.$route.query.q
            }, null, 8, ["value"]), [
              [_vShow, false]
            ])
          ]),
          _: 1
        }, 8, ["search-client", "index-name", "routing"])
      ], 512)
    ]),
    _: 1
  }, 8, ["search-query"]))
}